import type { ActurisSyncStatus } from './types';

const POLL_INTERVAL_MS = 2000;

export const shouldPollSyncStatus = (
  status: string | null | undefined,
  hasUsername: boolean,
): boolean => {
  return (
    status === 'pending' || status === 'syncing' || (hasUsername && !status)
  );
};

export const getPollInterval = (
  status: string | null | undefined,
  hasUsername: boolean,
): number | false => {
  return shouldPollSyncStatus(status, hasUsername) ? POLL_INTERVAL_MS : false;
};

export const normalizeSyncStatus = (
  rawStatus: string | null | undefined,
  hasUsername: boolean,
  isConfigComplete: boolean,
): ActurisSyncStatus => {
  if (!hasUsername) return 'not_configured';
  if (!rawStatus) return null;

  if (rawStatus === 'pending' || rawStatus === 'syncing') return 'syncing';
  if (rawStatus === 'error') return 'error';

  if (rawStatus === 'success') {
    return isConfigComplete ? 'ready' : 'incomplete';
  }

  if (rawStatus === 'ready') return 'ready';
  if (rawStatus === 'incomplete') return 'incomplete';

  return null;
};

export const getMissingFieldLabels = (editableFields: string[]): string[] => {
  const fieldLabelMap: Record<string, string> = {
    office: 'Office',
    account_executive: 'Account Executive',
    account_handler: 'Account Handler',
    team: 'Team',
  };

  return editableFields
    .map((field) => fieldLabelMap[field] || field)
    .filter(Boolean);
};
